module.exports = __webpack_public_path__ + "static/047.thumb-1c2356619a031e54c21e94780c320747.jpg";